import type { Customer } from '@nsd/core';
import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { ErrorBox, Loading, Money, Panel, api, useLoad, when } from '../ui.tsx';
import { OrderList } from './Orders.tsx';

export function Customers() {
  const [rows, setRows] = useState<Customer[]>([]);
  const [cursor, setCursor] = useState<string | undefined>();
  const [filter, setFilter] = useState('');
  const { error, loading } = useLoad(async () => {
    const r = await api.customers();
    setRows(r.customers);
    setCursor(r.cursor);
    return r;
  });
  const more = async () => {
    const r = await api.customers(cursor);
    setRows((x) => [...x, ...r.customers]);
    setCursor(r.cursor);
  };
  const f = filter.trim().toLowerCase();
  const shown = f ? rows.filter((c) => `${c.firstName} ${c.lastName} ${c.email}`.toLowerCase().includes(f)) : rows;
  return (
    <>
      <h1>Customers</h1>
      <input className="search" placeholder="Search name or email" value={filter} onChange={(e) => setFilter(e.target.value)} />
      <ErrorBox error={error} />
      {loading && !rows.length ? (
        <Loading />
      ) : (
        <ul className="olist">
          {shown.map((c) => (
            <li key={c.email}>
              <Link className="orow orow--cust" to={`/customers/${encodeURIComponent(c.email)}`}>
                <span className="orow__who">
                  {c.firstName} {c.lastName}
                  <small>{c.email}</small>
                </span>
                <span className="orow__qty">{c.orderCount} orders</span>
                <span className="orow__total"><Money cents={c.totalSpentCents} /></span>
                <span className="orow__when">Last {when(c.lastOrderAt)}</span>
              </Link>
            </li>
          ))}
        </ul>
      )}
      {cursor && <button className="btn btn--ghost" onClick={() => void more()}>Load more</button>}
    </>
  );
}

export function CustomerDetail() {
  const email = decodeURIComponent(useParams()['email'] ?? '');
  const { data, error, loading } = useLoad(() => api.customer(email), [email]);
  if (loading && !data) return <Loading />;
  if (!data) return <ErrorBox error={error} />;
  const c = data.customer;
  const a = c.defaultAddress;
  return (
    <>
      <p><Link to="/customers">Customers</Link></p>
      <h1>{c.firstName} {c.lastName}</h1>
      <div className="cols">
        <Panel title="Contact">
          <p>
            <a href={`mailto:${c.email}`}>{c.email}</a>
            {c.phone && <><br /><a href={`tel:${c.phone}`}>{c.phone}</a></>}
          </p>
          {a && <pre className="address">{[a.address1, a.address2, `${a.city} ${a.province}  ${a.postalCode}`].filter(Boolean).join('\n')}</pre>}
        </Panel>
        <Panel title="History">
          <p>{c.orderCount} orders, <Money cents={c.totalSpentCents} /> placed in total</p>
          <p className="muted">First {when(c.firstOrderAt)} · last {when(c.lastOrderAt)}</p>
        </Panel>
      </div>
      <Panel title="Orders">
        <OrderList orders={data.orders} />
      </Panel>
    </>
  );
}
